import { FETCH_USERS, CLEAR_USERS } from '#action/types';

const defaultState = [];

export default function (state = defaultState, action) {
  switch (action.type) {
    case FETCH_USERS:
      return action.payload;
    case CLEAR_USERS:
      return defaultState;
    default:
      return state;
  }
}
